module.exports = __webpack_public_path__ + "static/img/version_icon_gray.76f1bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/version_icon_gray.png
// module id = a0ww
// module chunks = 1